import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import useKeyboardControlForTabs from 'hooks/useKeyboardControlForTabs';
import PDPDesktopConfigThumbnails from '../PDPDesktopConfigThumbnails';
import PDPDesktopStudioThumbnails from '../PDPDesktopStudioThumbnails';
const DEFAULT_CONFIGURATION_PHOTOS = [];
const DEFAULT_DIMENSION_SHOT_PHOTOS = [];
const DEFAULT_STUDIO_PHOTOS = [];
const DEFAULT_OPEN_MODAL_CALLBACK = () => {};
const PDPDesktopThumbnails = ({
  configurationPhotos = DEFAULT_CONFIGURATION_PHOTOS,
  isMechanicalOpen = null,
  toggleMechanicalOpen,
  dimensionsImage,
  shouldShowDimensionThumbnail = false,
  dimensionShotUrls = DEFAULT_DIMENSION_SHOT_PHOTOS,
  enableCrops,
  introVideoId,
  isConfigFlipped = false,
  isCylindoConfigurationPhotos = false,
  isEditOrder = false,
  isVideoSelected,
  loading = false,
  mode = 'pdp',
  openModal = DEFAULT_OPEN_MODAL_CALLBACK,
  pdpIsModularBYOProduct = false,
  productName,
  selectedPhoto = null,
  setIsVideoSelected,
  setSelectedPhoto,
  studioPhotos = DEFAULT_STUDIO_PHOTOS,
  viewGalleryImageEvent
}) => {
  const buttonWrapperRef = useRef(null);
  useKeyboardControlForTabs(buttonWrapperRef);
  const showShownIn = mode === 'pdp';
  useEffect(() => {
    if (pdpIsModularBYOProduct && !loading) {
      setSelectedPhoto?.({
        type: 'configuration',
        index: 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);
  if (loading) {
    return <div className={classNames('flex justify-between mt-4 mx-0 mb-0 w-full', {
      'max-[1023px]:md:items-stretch max-[1023px]:md:flex-col max-[1023px]:md:w-full [&>div+div]:max-[1023px]:md:mt-2': mode === 'quickview'
    })}>
        <div className={classNames('flex-[3] w-[30%] max-[1461px]:flex-[5] max-[1461px]:w-1/2', {
        'max-[1023px]:md:!flex-[initial] max-[1023px]:md:!w-full': mode === 'quickview'
      })}>
          <PDPDesktopStudioThumbnails loading mode={mode} />
        </div>

        <div className={classNames('flex flex-[4] justify-center w-2/5 max-[1461px]:justify-end max-[1461px]:flex-[5] max-[1461px]:w-1/2', {
        '!justify-end': !showShownIn,
        'max-[1023px]:md:!flex-[initial] max-[1023px]:md:!justify-center max-[1023px]:md:!w-full': mode === 'quickview'
      })}>
          <PDPDesktopConfigThumbnails loading />
        </div>

        {!!showShownIn && <div className="items-center flex flex-[3] justify-end w-[30%] max-[1461px]:hidden" />}
      </div>;
  }
  return <div className={classNames('flex justify-between mt-4 mx-0 mb-0 w-full', {
    'max-[1023px]:md:items-stretch max-[1023px]:md:flex-col max-[1023px]:md:w-full [&>div+div]:max-[1023px]:md:mt-2': mode === 'quickview'
  })} ref={buttonWrapperRef}>
      <VisuallyHidden>
        Clicking on the following button will update the content above.
      </VisuallyHidden>

      <div className={classNames('flex-[3] w-[30%] max-[1461px]:flex-[5] max-[1461px]:w-1/2', {
      'max-[1023px]:md:!flex-[initial] max-[1023px]:md:!w-full': mode === 'quickview'
    })}>
        {!!studioPhotos.length && <PDPDesktopStudioThumbnails enableCrops={enableCrops} photos={studioPhotos} openModal={openModal} selectedPhoto={selectedPhoto && selectedPhoto.type === 'studio' ? selectedPhoto.src : null} setSelectedPhoto={setSelectedPhoto} introVideoId={introVideoId} setIsVideoSelected={setIsVideoSelected} isVideoSelected={isVideoSelected} viewGalleryImageEvent={viewGalleryImageEvent} mode={mode} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />}
      </div>

      <div className={classNames('flex flex-[4] justify-center w-2/5 max-[1461px]:justify-end max-[1461px]:flex-[5] max-[1461px]:w-1/2', {
      '!justify-end': !showShownIn,
      'max-[1023px]:md:!flex-[initial] max-[1023px]:md:!justify-center max-[1023px]:md:!w-full': mode === 'quickview'
    })}>
        <PDPDesktopConfigThumbnails enableCrops={enableCrops} photos={configurationPhotos} isMechanicalOpen={isMechanicalOpen} toggleMechanicalOpen={toggleMechanicalOpen} dimensionsImage={dimensionsImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} dimensionShotUrls={dimensionShotUrls} selectedPhoto={selectedPhoto && (selectedPhoto.type === 'configuration' || selectedPhoto.type === 'cylindo' || selectedPhoto.type === 'dimensional' || pdpIsModularBYOProduct && selectedPhoto.type === 'buildyourown') ? selectedPhoto : null} setSelectedPhoto={setSelectedPhoto} isConfigFlipped={isConfigFlipped} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} />
      </div>

      {!!showShownIn && <div className="items-center flex flex-[3] justify-end w-[30%] max-[1461px]:hidden">
          {!!selectedPhoto && selectedPhoto.type === 'studio' && <PDPShownIn isEditOrder={isEditOrder} showInactiveUpholstery productName={productName} optionId={selectedPhoto.optionId} valueId={selectedPhoto.valueId} upholsteryName={selectedPhoto.upholsteryName} />}
        </div>}
    </div>;
};
PDPDesktopThumbnails.propTypes = {
  configurationPhotos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  isMechanicalOpen: PropTypes.bool,
  toggleMechanicalOpen: PropTypes.func,
  dimensionsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  shouldShowDimensionThumbnail: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  isEditOrder: PropTypes.bool,
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  introVideoId: PropTypes.string,
  introVideoIds: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string
  }),
  isConfigFlipped: PropTypes.bool,
  isCylindoConfigurationPhotos: PropTypes.bool,
  isVideoSelected: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  openModal: PropTypes.func,
  productName: PropTypes.string,
  selectedPhoto: PropTypes.shape({
    type: PropTypes.oneOf(['buildyourown', 'configuration', 'cylindo', 'dimensional', 'studio']),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string
  }),
  setSelectedPhoto: PropTypes.func,
  setIsVideoSelected: PropTypes.func,
  studioPhotos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  viewGalleryImageEvent: PropTypes.func
};
export default PDPDesktopThumbnails;